import Expenses from "./Expenses/Expenses";
import Incomes from "./Income/Incomes";
import LogInPage from "./Login/LogInPage";
import React, { useState, useContext } from "react";
import Header from "./header/Header";
import CreateCategory from "./Expenses/CreateCategory";
import AuthContext from "./store/auth-context";
import autoTable from "jspdf-autotable";
import { jsPDF } from "jspdf";
import Profile from "./Profile/Profile";
import "./App.css";

function App() {
  const authCtx = useContext(AuthContext);
  const isLoggedIn = authCtx.isLoggedIn;

  function downloadPdf() {
    let incomes = [];
    authCtx.incomes.forEach((element) => {
      let x = [];
      x.push(element.source);
      x.push("$" + element.amount);
      incomes.push(x);
    });
    let exp = [];
    authCtx.expenses.forEach((element) => {
      let x = [];
      x.push(element.title);
      x.push("$" + element.categoryTotal);
      let expensesIndvid = [];

      element.expenses.forEach((e) => {
        if(e.expenseTitle){
        let a = e.expenseTitle + ": $" + (e.expenseAmount);
        expensesIndvid.push(a);
        }
      });

      // expensesIndvid.shift();
      // expensesIndvid.shift();
      let strExpenses = expensesIndvid.join(",\n");
      x.push(strExpenses);
      exp.push(x);
    });

    const doc = new jsPDF();
    doc.text("Income", 15, 10);
    doc.autoTable({
      head: [["Source", "Amount", ""]],
      body: [...incomes],
      foot: [["Total:", "$" + authCtx.totalIncome]],
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 60 },
        2: { cellWidth: 60 },
      },
    });
    let finalY = doc.previousAutoTable.finalY + 10; //this gives you the value of the end-y-axis-position of the previous autotable.
    doc.text("Expenses", 15, finalY); //you use the variable and add the number of pixels you want it to move.
    doc.text("", 15, finalY + 20); //you use the variable and add the number of pixels you want it to move.

    doc.autoTable({
      head: [["Category", "Amount", "Expenses"]],
      body: [...exp],
      foot: [["Total:", "$" + authCtx.totalExpense]],
      startY: finalY + 5,
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 60 },
        2: { cellWidth: 60 },
      },
    });
    let finalY2 = doc.previousAutoTable.finalY + 10; //this gives you the value of the end-y-axis-position of the previous autotable.
    doc.text("Balance", 15, finalY2); //you use the variable and add the number of pixels you want it to move.

    doc.autoTable({
      head: [["Total Income", "Total Expenses", "Balance"]],
      body: [
        [
          "$" + authCtx.totalIncome,
          "$" + authCtx.totalExpense,
          "$" +
            (
              parseFloat(authCtx.totalIncome) - parseFloat(authCtx.totalExpense)
            ).toString(),
        ],
      ],
      startY: finalY2 + 5,
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 60 },
        2: { cellWidth: 60 },
      },
    });
    doc.save("Budget.pdf");
  }

  return (
    <>
      {isLoggedIn == false && <LogInPage></LogInPage>}
      {isLoggedIn == true && authCtx.profile && <Profile></Profile>}
      {isLoggedIn && !authCtx.profile && (
        <>
          <Header downloadPdf={downloadPdf}></Header>
          <div className="container-fluid">
            <div className="row top">
              <div className="col-md-6">
                <Incomes></Incomes>
              </div>
              <div className="col-md-6 expensesBox">
                <Expenses></Expenses>
              </div>
              <div>
                {authCtx.totalIncome - authCtx.totalExpense >= 0 && (
                  <h3 className="balancePos ">
                    Balance: ${authCtx.totalIncome - authCtx.totalExpense}
                  </h3>
                )}
                {authCtx.totalIncome - authCtx.totalExpense < 0 && (
                  <h3 className="balanceNeg ">
                    Balance: ${authCtx.totalIncome - authCtx.totalExpense}
                  </h3>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default App;
